// extracted by mini-css-extract-plugin
module.exports = {"mainWindow":"style_mainWindow__1D3_i","journeyContent":"style_journeyContent__EGZVT","left":"style_left__1TbGa","right":"style_right__1XjVG"};